// extracted by mini-css-extract-plugin
export default {"CommentBox":"comment-module__CommentBox--nBFgM"};